import { ActiveView, PasswordPolicy } from "@/modules/login/models/state";
import { Status, statusErrorMap } from "@/modules/login/models/api";
import { MutationTree } from "vuex";
import { log } from "@/core/logger";
import { LoginPageState } from "@/modules/login/store/state";
import { LoginMutations } from "./types";

const mutations: MutationTree<LoginPageState> = {
  [LoginMutations.SET_ERROR_MESSAGE](state: LoginPageState, payload: { status: Status }): void {
    let errorMessage = "";
    if (statusErrorMap.hasOwnProperty(payload.status)) {
      errorMessage = statusErrorMap[payload.status];
    } else {
      errorMessage = statusErrorMap["UNKNOWN_ERROR"];
    }
    log(`Setting error message: "${errorMessage}"`);
    state.error.message = errorMessage;
  },

  [LoginMutations.DELETE_ERROR_MESSAGE](state: LoginPageState): void {
    log(`Deleting error message`);
    state.error.message = "";
  },

  [LoginMutations.SET_LOCKED_MESSAGE](
    state: LoginPageState,
    payload: { failedLoginTimeout: number }
  ): void {
    const errorMessage = `User locked, try again in ${payload.failedLoginTimeout} minutes`;
    log(`Setting locked message: "${errorMessage}"`);
    state.error.message = errorMessage;
    state.error.timeout = payload.failedLoginTimeout;
  },

  [LoginMutations.SET_PASSWORD_EXPIRED](
    state: LoginPageState,
    payload: { passwordPolicy: PasswordPolicy }
  ): void {
    log(`Password expired. Navigating to the password expiration page`);
    state.changePassword.policy = payload.passwordPolicy;
    state.activeView = ActiveView.ChangePassword;
  },
};

export default mutations;
